import React from 'react';
import './index.css';
import styled from '@emotion/styled';
import CalendarIcon from './icons/Calendar.svg';
import MailIcon from './icons/Mail.svg';
import PlannerIcon from './icons/Planner.svg';

type ApplicationProps = {
  name: string;
  icon: string;
  link?: string;
};

const ApplicationWrapper = styled.button`
  display:flex;
  align-items: center;
  padding: 16px 0 16px 16px;
  gap: 24px;
  min-width: 275px;
  max-width: 275px;
  cursor: pointer;
  border-top: 1px solid ${({ theme }) => theme.colors.gray};
  border-radius: 16px;
  background-color: transparent;
  transition: background-color 0.2s ease-in-out;
  user-select: none;
  &:hover {
    // .1 opacity
    background-color: ${({ theme }) => theme.colors.primaryColor + '1A'};
  }
  &:active {
    // .25 opacity
    background-color: ${({ theme }) => theme.colors.primaryColor + '40'};
  }
  &:focus {
    background-color: ${({ theme }) => theme.colors.primaryColor + '1A'};
  }
`;

const Application = ({ name, icon, link }: ApplicationProps) => {
  return (
    <ApplicationWrapper onClick={() => link && window.open(link, '_blank')}>
      <img className='applications-item-icon' src={icon} alt={name} />
      <span className='medium-title applications-item-text'>{name}</span>
    </ApplicationWrapper>
  );
};

const applications: ApplicationProps[] = [
  {
    name: 'Calendar',
    icon: CalendarIcon,
    link: 'https://calendar.astin.net/',
  },
  {
    name: 'Mail',
    icon: MailIcon,
    link: 'https://mail.astin.net/',
  },
  {
    name: 'Planner',
    icon: PlannerIcon,
    link: 'https://planner.astin.net/',
  },
];

export default function ApplicationsPage() {
  return (
    <div className='applications-section'>
        <h2 className='new-h2'>Додатки</h2>
        <div className='applications-list'>
          {/* 4 columns, first item in col1, second in col2 etc. */}
          {applications.map((application, index) => {
            
            const column = index % 4;
            const row = Math.floor(index / 4);
            const gridArea = `${row + 1} / ${column + 1} / ${row + 2} / ${column + 2}`;
            console.log(gridArea);
            return <Application key={application.name} {...application} />;

          })}

        </div>
    </div>
  );
}